import { render } from "./tblFicha.vue?vue&type=template&id=0becd198&scoped=true"
import script from "./tblFicha.vue?vue&type=script&lang=js"
export * from "./tblFicha.vue?vue&type=script&lang=js"

import "./tblFicha.vue?vue&type=style&index=0&id=0becd198&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0becd198"]])

export default __exports__